import { IFormValues } from '../types';

const initialValues: IFormValues = {
  name: '',
};

export default initialValues;
